import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LabelsService } from '@app/services/app/labels.service';
import { InterfaceListenerService } from '@core/services/interface-listener/interface-listener.service';

import * as Objects from '@core/objects';
import * as Access from '@app/models/access';

@Component({
    selector: 'app-helpers-labels-edit-diff-box',
    templateUrl: './edit-diff-box.component.html',
    styleUrls: ['./edit-diff-box.component.scss']
})
export class HelpersLabelsEditDiffBoxComponent implements OnInit, OnChanges, OnDestroy {

    // texts 
    @Input() searchPlaceholder: string = "Search for tags here";
    @Input() headerText: string = "";
    @Input() searchFoundText: string = "";
    // control variables 
    @Input() minLabels: number = 0;
    @Input() edit: boolean = true; // in case edition is not allowed form parent - labels are fixed
    @Input() fullEditMode: boolean = false; // show full edit mode ( with add/remove for all tags) or only remove extra tags from the project
    @Input() addControl: boolean = true; // allow add labels or not for future 
    @Input() allowClose: boolean = false; // allow close editor in the x
    // data inputs
    @Input() project: Objects.Request;
    @Input() labels: Array<Objects.Label> = []; // additional labels or labels to edit
    @Input() availableTagGroups: Array<Objects.Label[]> = []; // all available labels to add
    // action emitters
    @Output() labelsChange = new EventEmitter<Array<Objects.Label>>();
    @Output() close = new EventEmitter();

    public input: string = ''
    // to different labels
    public diffLabels: Array<Objects.Label> = [];
    public matchLabels: Array<Objects.Label> = [];
    // permissions to add tags (in combination with given addControl )
    public access: Access.AccessLabels = {
        access_label_add: false
    }
    public labelsToExclude: Array<Objects.Label> = [];
    public showGroups: boolean = false;
    private wasInside: boolean = false;
    protected subs: Subscription = new Subscription();

	constructor(protected labelsSrv: LabelsService, private iListenerSrv: InterfaceListenerService){}

	ngOnInit(){  
        // load access for add label
        this.labelsSrv.loadAccess();
        this.subs.add(
            this.labelsSrv.selectAccess().subscribe((access: Access.AccessLabels) => {
                this.access = access;
                console.debug( " access labels loadeed ",access)
            })
        );
        
        // Subscribe to document clicks to close groups selector when clicking outside
        this.subs.add(
            this.iListenerSrv.getDocuementClicked$().subscribe((value: any) => {
                if (this.showGroups && !this.wasInside) {
                    this.showGroups = false;
                } else {
                    this.wasInside = false;
                }
            })
        );
        
        this.updateCheckLabels();
	}

    ngOnChanges(changes: SimpleChanges) {
        if(changes.labels){
            this.updateCheckLabels();
        }
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
        this.input = ''; // clean typed search
    }

    removeLabel(label: Objects.Label) {
        this.labels = this.labels.filter((l: Objects.Label) => label.id != l.id);
        this.updateCheckLabels();
        this.emit();
    }

    addLabel(label: Objects.Label) {
        let labels = this.labels.filter((l: Objects.Label) => label.id == l.id);
        if(labels.length>0)
            return;
        this.labels = [...this.labels, label];
        this.updateCheckLabels();
        this.emit();
    }

    emit() {
        this.labelsChange.emit(this.labels);
    }

    private updateCheckLabels() {
        if(this.project == null){
            this.diffLabels = this.labels;
            this.labelsToExclude = [...this.diffLabels]; // update exclude in search
            return;
        }
        if (this.availableTagGroups?.length == 1 && this.getDiffLabels(this.availableTagGroups[0]).length != 0) {
            // we need to add default group labels availableGroups to let user decide 
            // if only one group is available and it has some diff labels, 
            // we show them as default to add and let user decide if they want select default group or not
            this.availableTagGroups.push(this.project.labels);
        }
        
        this.diffLabels = this.labels.filter((label: Objects.Label) => !this.project.labels.some((l) => l.id == label.id));
        this.matchLabels = this.labels.filter((label: Objects.Label) => this.project.labels.some((l) => l.id == label.id));
        this.labelsToExclude = [...this.matchLabels,...this.diffLabels];
    }

    getDiffLabels(currentLabels: Array<Objects.Label>) : Array<Objects.Label> {
        if(this.project == null)
            return currentLabels;
        return currentLabels.filter((label: Objects.Label) => !this.project.labels.some((l) => l.id == label.id));
    }

    /**
     * Check if all given labels match the diffLabels array
     * @param groupLabels Labels to check against diffLabels
     * @returns true if all group labels are present in labels
     */
    checkCurrentLabels(groupLabels: Array<Objects.Label>): boolean {
        if (!groupLabels) {
            return true;
        }

        return groupLabels.length == this.labels.length && groupLabels.every((label: Objects.Label) =>
            this.labels.some((l: Objects.Label) => l.id === label.id)
        );
    }

    onSelectGroup(labels: Objects.Label[]) {
        this.labels = [...labels];
        this.showGroups = false;
        this.wasInside = false;
        this.emit();
    }

    toggleGroups() {
        this.showGroups = !this.showGroups;
        this.wasInside = true;
    }

}
